module.exports = __webpack_public_path__ + "img/pagibig.ba8ff361.svg";